module.exports = __webpack_public_path__ + "img/three_5.276571f3.png";